import { observable } from "mobx";
import { api_adm } from "../../api";
import { INotaVar } from "../../model";
import { toast } from "react-toastify";

class _NotaVarStore {

  obs = observable({
    vars: [] as INotaVar[]
  })

  async load(): Promise<void> {
    try {
      return api_adm.get("/api/admin/nota_vars").then(resp => {
        this.obs.vars = [];
        this.obs.vars = resp.data
      });
    } catch (ex) {
      toast.error("Erro ao carregar Variáveis!", {});
    }
  }

  handleRefresh() {
    window.location.reload();
  }

  async get(id: string): Promise<INotaVar> {
    try {
      let resp = await api_adm.get(`/api/admin/nota_vars/${id}`);
      return resp.data;
    } catch (ex) {
      toast.error("Erro ao carregar Variavel!", {});
    }
  }

  put(notaVar: INotaVar): Promise<any> {
    if (notaVar._id) {
      return api_adm.put(`/api/admin/nota_vars/${notaVar._id}`, notaVar);
    } else {
      return api_adm.post("/api/admin/nota_vars", notaVar);
    }
  }
}

export const NotaVarStore = new _NotaVarStore();
